module.exports = __webpack_public_path__ + "img/5_diamond.b5d53164.jpg";